// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__G0aCy","validationTips":"StatementDescriptor_validationTips__15Uda"};